export enum RecipientTypeEnum {
  Show = 'Show',
  Add = 'Add',
}
